import { useState, useEffect } from 'react';

export const useModalAnimation = (isOpen, onClose, duration = 200) => {
    const [isVisible, setIsVisible] = useState(isOpen);
    const [isClosing, setIsClosing] = useState(false);
    const [prevIsOpen, setPrevIsOpen] = useState(isOpen);

    if (isOpen !== prevIsOpen) {
        setPrevIsOpen(isOpen);
        if (isOpen) {
            setIsVisible(true);
            setIsClosing(false);
        } else if (isVisible) {
            setIsClosing(true);
        }
    }

    // Fallback: Ensure modal closes even if animation end event doesn't fire
    useEffect(() => {
        let timeoutId;
        if (isClosing) {
            timeoutId = setTimeout(() => {
                if (isVisible) {
                    setIsVisible(false);
                    setIsClosing(false);
                    if (onClose) {
                        if (typeof onClose === 'function') {
                            onClose();
                        } else {
                            console.error('useModalAnimation: onClose is not a function', onClose);
                        }
                    }
                }
            }, duration + 50); // Wait slightly longer than animation duration
        }
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [isClosing, duration, isVisible, onClose]);

    const handleAnimationEnd = () => {
        if (isClosing) {
            setIsVisible(false);
            setIsClosing(false);
            if (onClose) {
                if (typeof onClose === 'function') {
                    onClose();
                } else {
                    console.error('useModalAnimation: onClose is not a function', onClose);
                }
            }
        }
    };

    return {
        isVisible,
        isClosing,
        handleAnimationEnd
    };
};
